


















import Vue from 'vue';

export default Vue.extend({
  props: {
    single: Boolean,
    title: {
      type: String,
      required: true,
    },
  },
});
